var isAppInForeground = function () {
    return true;
};
export { isAppInForeground };
